/**
 *  @class
 *  @function FacetsToggle
 */
console.log('facetjs');
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        console.log("testing");
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    // Code by Ruby - Convx - #3304 TL-3514 - comment out auto-search on input
    // this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // End of #3304 TL-3514
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
        if (typeof CollectionGridView !== 'undefined') {
          try { new CollectionGridView(); } catch (e) {}
        }

        // Code by Ruby - Convx - TL-3569 - Re-initialize FacetFiltersForm elements after re-render
        FacetFiltersForm.reinitializeElements();
        // End of TL-3569

        // Code by Ruby - Convx - #3304 TL-3514
        if (window.shouldOpenDetails) {
          setTimeout(() => {
            const mainFacetsContainer = document.querySelector('.facets-desktop-container');
            if (mainFacetsContainer) {
              const mainDetails = mainFacetsContainer.querySelectorAll('details.js-filter');
              mainDetails.forEach(detail => {
                if (!detail.hasAttribute('open')) {
                  detail.setAttribute('open', '');
                }
              });
            }
            
            const mobileFacetsContainer = document.querySelector('#Facet-Drawer');
            if (mobileFacetsContainer) {
              const mobileDetails = mobileFacetsContainer.querySelectorAll('details.js-filter');
              mobileDetails.forEach(detail => {
                if (!detail.hasAttribute('open')) {
                  detail.setAttribute('open', '');
                }
              });
            }
          }, 200);
        }
        // End of #3304 TL-3514
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
    if (typeof CollectionGridView !== 'undefined') {
      try { new CollectionGridView(); } catch (e) {}
    }

    // Code by Ruby - Convx - TL-3569 - Re-initialize FacetFiltersForm elements after re-render
    FacetFiltersForm.reinitializeElements();
    // End of TL-3569

    // Code by Ruby - Convx - TL-3638
    FacetFiltersForm.filterCombinedListingProducts();
    // End of TL-3638

    // Code by Ruby - Convx - #3304 TL-3514
    if (window.shouldOpenDetails) {
      setTimeout(() => {
        const mainFacetsContainer = document.querySelector('.facets-desktop-container');
        if (mainFacetsContainer) {
          const mainDetails = mainFacetsContainer.querySelectorAll('details.js-filter');
          mainDetails.forEach(detail => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
            }
          });
        }
        
        const mobileFacetsContainer = document.querySelector('#Facet-Drawer');
        if (mobileFacetsContainer) {
          const mobileDetails = mobileFacetsContainer.querySelectorAll('details.js-filter');
          mobileDetails.forEach(detail => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
            }
          });
        }
      }, 200);
    }
    // End of #3304 TL-3514
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });

    // Code by Ruby - Convx - TL-3638
    FacetFiltersForm.filterCombinedListingProducts();
    // End of TL-3638
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  // Code by Ruby - Convx - TL-3638
  static filterCombinedListingProducts() {
    // Get active filters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const activeSizeFilters = [];
    const activeAvailabilityFilter = urlParams.get('filter.v.availability') === '1';
    
    // Get all size filter values from URL - check for various possible parameter formats
    urlParams.forEach((value, key) => {
      // Check for size filter parameters (Shopify uses filter.v.option.size format)
      const lowerKey = key.toLowerCase();
      if (lowerKey.includes('size') && (lowerKey.includes('filter.v.option'))) {
        activeSizeFilters.push(value);
      }
    });

    // Also check active filter checkboxes in the DOM to get size filters
    const sizeCheckboxes = document.querySelectorAll('input[type="checkbox"][name*="size"][name*="filter"]:checked');
    sizeCheckboxes.forEach(checkbox => {
      const value = checkbox.value;
      if (value && !activeSizeFilters.includes(value)) {
        activeSizeFilters.push(value);
      }
    });

    // If no size or availability filters are active, show all products
    if (activeSizeFilters.length === 0 && !activeAvailabilityFilter) {
      document.querySelectorAll('[data-combined-listing="true"]').forEach(card => {
        card.style.display = '';
      });
      return;
    }

    // Filter combined listing product cards
    document.querySelectorAll('[data-combined-listing="true"]').forEach(card => {
      let shouldShow = true;
      
      // Check size filter
      if (activeSizeFilters.length > 0) {
        const availableSizes = card.getAttribute('data-available-sizes') || '';
        const allSizes = card.getAttribute('data-all-sizes') || '';
        const sizesArray = availableSizes ? availableSizes.split('||').filter(s => s.trim() !== '') : [];
        const allSizesArray = allSizes ? allSizes.split('||').filter(s => s.trim() !== '') : [];
        
        // Check if any active size filter matches available sizes (if availability filter is on)
        // or all sizes (if availability filter is off)
        const sizesToCheck = activeAvailabilityFilter ? sizesArray : allSizesArray;
        const hasMatchingSize = activeSizeFilters.some(activeSize => {
          const normalizedActiveSize = activeSize.trim().toLowerCase();
          return sizesToCheck.some(size => {
            const normalizedSize = size.trim().toLowerCase();
            return normalizedSize === normalizedActiveSize;
          });
        });
        
        if (!hasMatchingSize) {
          shouldShow = false;
        }
      }
      
      // Check availability filter
      if (activeAvailabilityFilter && shouldShow) {
        const availableSizes = card.getAttribute('data-available-sizes') || '';
        const sizesArray = availableSizes ? availableSizes.split('||').filter(s => s.trim() !== '') : [];
        
        // If size filter is also active, check if the matching size is available
        if (activeSizeFilters.length > 0) {
          const hasAvailableMatchingSize = activeSizeFilters.some(activeSize => {
            const normalizedActiveSize = activeSize.trim().toLowerCase();
            return sizesArray.some(size => {
              const normalizedSize = size.trim().toLowerCase();
              return normalizedSize === normalizedActiveSize;
            });
          });
          if (!hasAvailableMatchingSize) {
            shouldShow = false;
          }
        } else {
          // If only availability filter is active, check if there are any available sizes
          if (sizesArray.length === 0) {
            shouldShow = false;
          }
        }
      }
      
      // Show or hide the card
      card.style.display = shouldShow ? '' : 'none';
    });
  }
  // End of TL-3638

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  // Code by Ruby - Convx - TL-3569
  static reinitializeElements() {
    const facetForms = document.querySelector('facet-filters-form.facets-desktop-container');
    if(facetForms){
      const applyButton = facetForms.querySelector('.facets-apply-button');
      if (applyButton && !applyButton.hasAttribute('data-listener-added')) {
        applyButton.addEventListener('click', (event) => {
          event.preventDefault();
          const formElement = facetForms.querySelector('form');
          if (formElement) {
            
            if (applyButton.dataset.checkAvailability === 'true') {
              const availabilityCheckbox = formElement.querySelector('input[name="filter.v.availability"]');
              if (availabilityCheckbox && !availabilityCheckbox.checked) {
                availabilityCheckbox.checked = true;
              }
            }
            
            const formData = new FormData(formElement);
            const searchParams = new URLSearchParams(formData);
            
            const currentParams = new URLSearchParams(window.location.search);
            if (!searchParams.has('sort_by') && currentParams.has('sort_by')) {
              searchParams.set('sort_by', currentParams.get('sort_by'));
            }

            if (searchParams.get('filter.v.price.gte') === "0.00") {
              searchParams.delete('filter.v.price.gte');
            }

            if (document.querySelector('.price_slider')) {
              if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
                searchParams.delete('filter.v.price.lte');
              }
            }
            
            if (applyButton.dataset.openDetails === 'true') {
              window.shouldOpenDetails = true;
            }
            
            FacetFiltersForm.renderPage(searchParams.toString());
            
            if (applyButton.classList.contains('mobile-filters-apply')) {
              const clickCapture = document.querySelector('.click-capture');
              if (clickCapture) {
                clickCapture.click();
              }
            }
          }
        });
        applyButton.setAttribute('data-listener-added', 'true');
      }
    }

    const sortBarForm = document.querySelector('#FacetFiltersForm-bar');
    if (sortBarForm) {
      try {
  if (window.iWish) {
    setTimeout(() => {
      iWish.checkIwishColl();
      iWishQV.init();
    }, 2000);
  }
} catch (e) {
  console.error(e);
}

      const sortSelect = sortBarForm.querySelector('select[name="sort_by"]');
      if (sortSelect && !sortSelect.hasAttribute('data-listener-added')) {
        sortSelect.addEventListener('change', (event) => {
          const form = sortBarForm;
          const formData = new FormData(form);
          const currentParams = new URLSearchParams(window.location.search);
          const sortValue = formData.get('sort_by');
          
          if (sortValue) {
            currentParams.set('sort_by', sortValue);
            FacetFiltersForm.renderPage(currentParams.toString());
          }
        });
        sortSelect.setAttribute('data-listener-added', 'true');
      }
    }
  }
  // End of TL-3569

  onSubmitHandler(event) {
    event.preventDefault();
    console.log('changed.............');
    const form = event.target.closest('form');
    const formData = new FormData(form);

    // If the Sort Bar form submitted, only update sort_by and preserve existing filters
    if (form && form.id === 'FacetFiltersForm-bar') {
      const currentParams = new URLSearchParams(window.location.search);
      const sortValue = formData.get('sort_by');
      if (sortValue) currentParams.set('sort_by', sortValue);
      FacetFiltersForm.renderPage(currentParams.toString(), event);
      return;
    }

    // Default behavior: build params from the form's fields
    const searchParams = new URLSearchParams(formData);
    // Preserve current sort_by if form doesn't include it (e.g., mobile filter-only form)
    const currentParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('sort_by') && currentParams.has('sort_by')) {
      searchParams.set('sort_by', currentParams.get('sort_by'));
    }
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    console.log("testing");
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const currentParams = new URLSearchParams(window.location.search);
    const targetParams = new URLSearchParams(url);
    // Preserve current sort_by if target does not explicitly set it
    if (!targetParams.has('sort_by') && currentParams.has('sort_by')) {
      targetParams.set('sort_by', currentParams.get('sort_by'));
    }
    FacetFiltersForm.renderPage(targetParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();

  // Code by Ruby - Convx - TL-3569 - sort functionality without apply button, and filter apply button functionality
  FacetFiltersForm.reinitializeElements();
  // End of TL-3569

  // Code by Ruby - Convx - TL-3638
  FacetFiltersForm.filterCombinedListingProducts();
  // End of TL-3638

  // Code by Ruby - Convx - #3304 TL-3514
  const mobileApplyButton = document.querySelector('.mobile-filters-apply');
  if (mobileApplyButton) {
    mobileApplyButton.addEventListener('click', (event) => {
      event.preventDefault();
      
      const mobileForm = document.querySelector('#FacetFiltersFormMobile');
      if (mobileForm) {
        
        const availabilityCheckbox = mobileForm.querySelector('input[name="filter.v.availability"]');
        if (availabilityCheckbox && !availabilityCheckbox.checked) {
          availabilityCheckbox.checked = true;
        }
        
        const formData = new FormData(mobileForm);
        const searchParams = new URLSearchParams(formData);
        
        const currentParams = new URLSearchParams(window.location.search);
        if (!searchParams.has('sort_by') && currentParams.has('sort_by')) {
          searchParams.set('sort_by', currentParams.get('sort_by'));
        }

        if (searchParams.get('filter.v.price.gte') === "0.00") {
          searchParams.delete('filter.v.price.gte');
        }

        if (document.querySelector('.price_slider')) {
          if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
            searchParams.delete('filter.v.price.lte');
          }
        }
        
        if (mobileApplyButton.dataset.openDetails === 'true') {
          window.shouldOpenDetails = true;
        }
        
        FacetFiltersForm.renderPage(searchParams.toString());

        const clickCapture = document.querySelector('.click-capture');
        if (clickCapture) {
          clickCapture.click();
        }
      } else {
        // console.log('Mobile form not found');
      }
    });
  } else {
    // console.log('Mobile Apply button not found');
  }
  // End of #3304 TL-3514
});